import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";
import { MonthlyReportModel, HeaderModel } from "./";

export type listMonthlyReportsRequest = {
  documentYear: number;
};

export type listMonthlyReportsResponse = {
  headers: HeaderModel[];
  monthlyReports: MonthlyReportModel[];
};

export const listMonthlyReports = async (request: listMonthlyReportsRequest) => {
  const response = await executeApiRequest(
    () => axios.get<listMonthlyReportsResponse>("/monthlyReports", { params: request }),
    false
  );

  return response?.data;
};
